<template>
    <div class="row pb-4 pt-2">
        <div class="col">
            <div class="card shadow">
                <div class="p-3">
                    <div class="row text-center">
                        <div class="col-6 col-lg-3 col-xl-3 border-right">
                            <b-badge pill variant="invoice-paid">
                                <span class="h5">สรุปยอดที่จ่ายแล้ว</span >
                            </b-badge>
                            <div class="h2 font-weight-bold">
                                {{ reportInvoice.listTotalInvoice.total_paid | numFormat('0,0.00') }} 
                                <span class="h5">บาท</span>
                            </div>
                        </div>
                        <div class="col-6 col-lg-3 col-xl-3 border-right">
                            <b-badge pill variant="invoice-paid">
                                <span class="h5" v-b-tooltip title="นิติบุคคลหักภาษี ณ ที่จ่าย จากค่าขนส่ง 1% และค่าบริการ 3%">ยอดรวมที่จะได้รับ (แบบหักภาษี ณ ที่จ่าย)</span>
                            </b-badge>
                            <div class="h2 font-weight-bold">{{ reportInvoice.listTotalInvoice.total_paid_wht | numFormat('0,0.00') }}  
                                <span class="h5">บาท</span>
                            </div>
                        </div>
                        <div class="col-6 col-lg-3 col-xl-3 border-right">
                            <b-badge pill variant="invoice-unpaid">
                                <span class="h5">สรุปยอดที่ยังไม่จ่าย</span>
                            </b-badge>
                            <div class="h2 font-weight-bold">{{ reportInvoice.listTotalInvoice.total_unpaid | numFormat('0,0.00') }}
                                <span class="h5">บาท</span>
                            </div>
                        </div>
                        <div class="col-6 col-lg-3 col-xl-3 border-right">
                            <b-badge pill variant="invoice-unpaid">
                                <span class="h5" v-b-tooltip title="นิติบุคคลหักภาษี ณ ที่จ่าย จากค่าขนส่ง 1% และค่าบริการ 3%">ยอดรวมที่ยังไม่จ่าย (แบบหักภาษี ณ ที่จ่าย)</span>
                            </b-badge>
                            <div class="h2 font-weight-bold">{{ reportInvoice.listTotalInvoice.total_unpaid_wht | numFormat('0,0.00') }} 
                                <span class="h5">บาท</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        reportInvoice: Object
    }
}
</script>